import { usePermissions } from '../contexts/PermissionContext';

export function useCan(permiso: string): boolean {
  const { can } = usePermissions();
  return can(permiso);
}
